import { Stack, styled } from "@mui/material"

export const SelfRegistrationLegalEntityStyledStack = styled(Stack)(() => ({
    display: "inline-flex",
    fontWeight: "500",
}))
